import moment from 'moment';

const dataLayer = window.dataLayer || [];

const gtmEvents = {
  analyticsDeleteScheduleReport: 'analyticsDeleteScheduleReport',
};

export function JobDeleteModalController(
  $scope,
  $uibModalInstance,
  scheduleToDelete,
  JobSchedulerService,
  gettextCatalog,
) {
  'ngInject';

  $scope.loading = false;
  $scope.errorFlag = false;
  $scope.errorText = '';
  $scope.schedule = scheduleToDelete;

  $scope.ok = function () {
    $scope.loading = true;

    dataLayer.push({
      event: gtmEvents.analyticsDeleteScheduleReport,
      data: {
        ...scheduleToDelete,
      },
    });

    JobSchedulerService.deleteSchedule(scheduleToDelete)
      .then(function () {
        $uibModalInstance.close(scheduleToDelete);
      })
      .catch(function () {
        $uibModalInstance.dismiss(gettextCatalog.getString('Error deleting schedule'));
        $scope.errorFlag = true;
      })
      .finally(function () {
        $scope.loading = false;
      });
  };
  $scope.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };
}

export function JobDetailController(
  $scope,
  $q,
  $sce,
  $rootScope,
  $uibModal,
  $stateParams,
  JobSchedulerService,
  $state,
  $filter,
  securityGroupsService,
  equipmentRepository,
  reportsRepository,
  appSettings,
  $log,
  usersService,
  gettextCatalog,
) {
  'ngInject';

  $scope.date = {};

  const refresh = function () {
    $scope.loading = true;

    JobSchedulerService.getSchedule($stateParams.id)
      .then(function (response) {
        $scope.schedule = response.data;
        const assetIds = [];
        for (let i = 0; i < $scope.schedule.equipment.length; i++) {
          assetIds.push($scope.schedule.equipment[i].id);
        }
        $scope.assetsSelected = assetIds.toString();
        $scope.reportPath = $scope.schedule.reportId;
        return reportsRepository.getReport($scope.reportPath);
      })
      .then(function (response) {
        $scope.report = response.data;
        $scope.parametersData =
          $scope.report.data.relationships.ssrsReport.data.attributes.parameters;
        setDateRangeValue($scope.parametersData);
      })
      .catch(function () {
        $scope.error = gettextCatalog.getString('Failed to get schedule');
      })
      .finally(function () {
        const rp = `${appSettings.VikingEndpoint}/default?path=${encodeURIComponent(
          $scope.schedule.reportPath,
        )}`;
        $scope.iFrameReportPath = $sce.trustAsResourceUrl(rp);
        $scope.$emit('$viewContentLoaded');
        $scope.loading = false;
      });
  };

  function setDateRangeValue(parametersData) {
    if (!parametersData) return;
    for (let i = 0; i < parametersData.length; i++) {
      const param = parametersData[i];
      if (param.name === 'drop_DateRange') {
        param.defaultValues[0] = $scope.schedule.reportParameters.drop_DateRange;
        return;
      }
    }
  }

  refresh();
  $scope.getEmails = function () {
    return JobSchedulerService.getNotificationEmails($scope.schedule);
  };

  $scope.iframeReportCallBack = function () {
    $scope.loadingReport = false;
    $scope.reportGenerated = true;
    $scope.$apply();
  };

  $scope.parameterRequired = function (name) {
    if (!$scope.parametersData) {
      return false;
    }
    for (let i = 0; i < $scope.parametersData.length; i++) {
      if ($scope.parametersData[i].name === name) {
        return true;
        // break;
      }
    }

    return false;
  };

  // Gets the path of the template for the parameters, some inputs are hidden from the UI
  // this is because we need form inputs to be able to POST to a iFrame
  $scope.getParamPath = function (name) {
    if (name.indexOf('drop_') === 0) {
      return 'pages/reports/reportview/reportparameters/_form.drop_.html';
    }
    if (name === 'dt_EndDate') {
      $scope.date.end = moment().format('YYYY-MM-DD');
      return 'pages/reports/reportview/reportparameters/_form.drop_DateRange.html';
    }
    if (name === 'AssetList') {
      let assetIds = '';

      for (let i = 0; i < $scope.schedule.equipment.length; i++) {
        if (i === 0) assetIds = $scope.schedule.equipment[i].id;
        else assetIds = `${assetIds  },${  $scope.schedule.equipment[i].id}`;
      }

      $scope.assetsSelected = assetIds;

      return 'pages/reports/reportview/reportparameters/_form.AssetList.html';
    }
    if (name === 'UnitOfMeasure') {
      $scope.unitOfMeasure = usersService.currentUser().claims.data.unitOfMeasure;
      return 'pages/reports/reportview/reportparameters/_form.user_unit_of_measure.html';
    }
    // not sure if needed keeping around for legacy purposes
    if (name === 'UserUOM') {
      $scope.userUOM = usersService.currentUser().claims.data.unitOfMeasure;
      return 'pages/reports/reportview/reportparameters/_form.user_uom.html';
    }
    if (name === 'TimeZoneId') {
      $scope.timeZoneId = usersService.currentUser().claims.data.timezone;
      return 'pages/reports/reportview/reportparameters/_form.time_zone_id.html';
    }
    if (name === 'UserTZ') {
      $scope.userTZ = moment
        .tz(Date.now(), usersService.currentUser().claims.data.timezone)
        .format('z');
      return 'pages/reports/reportview/reportparameters/_form.user_time_zone.html';
    }
    if (name === 'UserName') {
      $scope.userName = usersService.currentUser().username;
      return 'pages/reports/reportview/reportparameters/_form.user_name.html';
    }
    if (name === 'AccountId') {
      $scope.accountId = parseInt(usersService.currentUser().account.id);
      return 'pages/reports/reportview/reportparameters/_form.account_id.html';
    }

    return '';
  };

  $scope.deleteButtonPressed = function () {
    const modalInstance = $uibModal.open({
      animation: true,
      keyboard: false,
      backdrop: 'static',
      template: require('../_delete.schedule.confirmation.modal.html'),
      controller: 'JobDeleteModalController',
      size: 'sm',
      resolve: {
        scheduleToDelete() {
          return $scope.schedule;
        },
      },
    });
    modalInstance.result.then(
      function () {
        $state.go('reports.jobschedules');
      },
      function () {
        $scope.errorFlag = true;
        $scope.errorText = gettextCatalog.getString('Error deleting schedule');
      },
    );
  };
}
